import { RefObject, useEffect, useRef } from 'react'

export interface UseOutsideClick<TRef extends Node> {
  elementRef: RefObject<TRef>
}

const useOutsideClick = <TRef extends Node>(handler: () => void): UseOutsideClick<TRef> => {
  const elementRef = useRef<TRef>(null)

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        elementRef.current &&
        event.target instanceof Node &&
        !elementRef.current.contains(event.target)
      ) {
        handler()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [elementRef, handler])

  return { elementRef }
}

export default useOutsideClick
